export interface ColumnVisibility {
	[key: string]: boolean;
}

export interface SearchableColumn {
	field: string;
}
export class SearchFieldsUtils {
	static computeChildTableSearchFields(columns: SearchableColumn[], visibility: ColumnVisibility = {}): string[] {
		const effectiveVisibility =
			Object.keys(visibility).length > 0
				? visibility
				: columns.reduce((acc, col) => ({ ...acc, [col.field]: true }), {} as ColumnVisibility);

		const searchFields = columns
			.filter((column) => effectiveVisibility[column.field] !== false)
			.map((column) => this.mapChildTableFieldToSearchField(column.field))
			.filter((field) => field && field.length > 0);

		return searchFields;
	}

	private static mapChildTableFieldToSearchField(field: string): string {
		const fieldMapping: Record<string, string> = {
			titleSearchDisplayNameFull: 'indexed.titleSearchDisplayNameFull',
			releaseDate: 'indexed.releaseDate',
			runLength: 'indexed.runLength',
			uuid: 'indexed.uuid',

			editUse: 'indexed.editUse',
			editClasses: 'indexed.editClasses',
			editDescription: 'indexed.descriptions.description',

			sequenceNumber: 'relationship.sequenceInfo.number',
			distributionNumber: 'relationship.sequenceInfo.distributionNumber.distributionNumber',
			houseSequence: 'relationship.sequenceInfo.houseSequence.houseSequence',

			madeForRegions: 'indexed.madeForRegions.label',
			madeForRegionsExclude: 'indexed.madeForRegionsExclude.label',

			releaseYear: 'indexed.releaseYear',

			platformSpecification: 'indexed.alid.platformSpecification.label',
			alid: 'indexed.alid.identifier',
			versionLanguages: 'indexed.versionLanguages.label',

			entryClass: 'relationship.compilationEntryClass.label',
			entryNumber: 'relationship.compilationEntryNumber',
		};

		return fieldMapping[field] || '';
	}
}
